import React from 'react';
import { connect } from 'react-redux';
import { Badge, Overlay, Popover } from 'react-bootstrap';

import IntlFormSelector from 'components/intlForm/IntlFormSelector';

class IntlFormInlineSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.badgeRef = React.createRef();
  }

  componentDidUpdate = prevProps => {
    const { appIntl } = this.props;
    const { show } = this.state;

    if (show && appIntl.displayIntlForm !== prevProps.appIntl.displayIntlForm) {
      this.setState({ show: false });
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.timer);
  };

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => ({ show: !prevState.show }));
  };

  startTimer = () => {
    this.timer = setTimeout(() => {
      this.setState(prevState => ({ show: !prevState.show }));
    }, 300);
  };

  resetTimer = () => {
    clearTimeout(this.timer);
  };

  render() {
    const { appIntl, trigger } = this.props;
    const { show } = this.state;

    let events;
    switch (trigger) {
      case 'mouseover':
        events = {
          onMouseEnter: this.startTimer,
          onMouseLeave: this.resetTimer,
        };
        break;

      default:
        events = {
          onClick: this.handleClick,
        };
        break;
    }

    return (
      <span>
        <Badge ref={this.badgeRef} class="m-r-5 text-uppercase p-l-10 p-r-10" {...events}>
          {appIntl.displayIntlForm}
        </Badge>

        <Overlay
          show={show}
          target={this.badgeRef.current}
          placement="top"
          rootClose
          onHide={() => {
            this.setState({ show: false });
          }}
        >
          <Popover id="intl-form">
            <IntlFormSelector />
          </Popover>
        </Overlay>
      </span>
    );
  }
}
IntlFormInlineSelector.defaultProps = {
  trigger: 'click',
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default connect(mapStateToProps)(IntlFormInlineSelector);
